module.exports = __webpack_public_path__ + "media/icons/tapicerka-materialowa-uactive@2x-f66179c8.png";